document.addEventListener('DOMContentLoaded', () => {
  const variantInput = document.querySelector('select[name="id"], input[name="id"][type="hidden"]');
  if (!variantInput) return;

  /** Utility: Observe variant changes (swatches or dropdown) **/
  function onVariantChange(callback) {
    variantInput.addEventListener('change', () => callback(variantInput.value));
    const observer = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'attributes' && m.attributeName === 'value') {
          callback(variantInput.value);
        }
      });
    });
    observer.observe(variantInput, { attributes: true });
    callback(variantInput.value); // initial
  }

  /* -----------------------------------------------------------------------
     1. Image-with-text Section Variant Images
  ----------------------------------------------------------------------- */
  const imageWithTextScripts = document.querySelectorAll('script[id^="ImageWithTextVariantImages-"]');

console.log("Found ImageWithText sections:", imageWithTextScripts.length);

imageWithTextScripts.forEach((script, sectionIndex) => {
  const variantImages = JSON.parse(script.textContent);
  const sectionId = script.id.replace('ImageWithTextVariantImages-', '');
  const section = document.querySelector(`#shopify-section-${sectionId}`);
  if (!section) return;

  // Determine afbeeldingen for this section
  const offset = sectionIndex * 2;
  const field1 = `afbeelding_${offset + 1}`;
  const field2 = `afbeelding_${offset + 2}`;

  console.log(`Section ${sectionIndex + 1} → ${field1}, ${field2}`);

  //----------------------------------------------------
  // Picture replacement helper
  //----------------------------------------------------
  function setImageSources(img, url) {
    if (!img || !url) return;

    const picture = img.closest('picture');

    if (picture) {
      picture.querySelectorAll('source').forEach(source => {
        source.srcset = url;
        source.setAttribute('data-srcset', url);
      });

      const newImg = img.cloneNode(true);
      newImg.src = url;
      newImg.srcset = url;
      newImg.setAttribute('data-src', url);
      newImg.setAttribute('data-srcset', url);
      img.replaceWith(newImg);
    } else {
      img.src = url;
      img.srcset = url;
      img.setAttribute('data-src', url);
      img.setAttribute('data-srcset', url);
    }
  }

  //----------------------------------------------------
  // Section-based container selector (THIS IS THE FIX)
  //----------------------------------------------------
  function getImageContainer() {
    // Even index (0,2,4…) → use first image container
    // Odd index (1,3,5…)  → use last image container
    if (sectionIndex % 2 === 0) {
      return section.querySelector('.image-with-text__image-container:first-of-type');
    } else {
      return section.querySelector('.image-with-text__image-container:last-of-type');
    }
  }

  //----------------------------------------------------
  // Variant Change Handler
  //----------------------------------------------------
  function updateImageWithText(variantId) {
  const data = variantImages[variantId];
  if (!data) return;

  const containers = section.querySelectorAll('.image-with-text__image-container');

  if (!containers.length) {
    console.warn(`No image containers found for section ${sectionIndex + 1}`);
    return;
  }

  containers.forEach(container => {
    const wrappers = container.querySelectorAll(
      ':scope > .image-with-text__image-wrapper img'
    );

    const img1 = wrappers[0] || null;
    const img2 = wrappers[1] || null;

    if (data[field1] && img1) {
      setImageSources(img1, data[field1]);
    }

    if (data[field2] && img2) {
      setImageSources(img2, data[field2]);
    }
  });
}

  //----------------------------------------------------
  // Connect to variant change
  //----------------------------------------------------
  if (window.Shopify && Shopify.designMode) {
  document.addEventListener('variant:change', e => {
    if (e.detail?.sectionId === sectionId) {
      updateImageWithText(e.detail.variant?.id);
      updateVariantVideo(e.detail.variant?.id); // <-- new
    }
  });
} else if (typeof onVariantChange === 'function') {
  onVariantChange(variantId => {
    updateImageWithText(variantId);
    updateVariantVideo(variantId); // <-- new
  });
}

  });
  
  // Select all slide divs that contain the data attribute 
  const slides = document.querySelectorAll('[data-variant-media-ids]'); // A map to track if we've already tagged the first slide of each variant 
  const firstOfVariant = new Set();
  slides.forEach(slide => {
    const variantId = slide.getAttribute('data-variant-media-ids'); // If we haven't marked a slide for this variant yet 
    if (!firstOfVariant.has(variantId)) {
      slide.classList.add('first-of-variant-gallery');
      firstOfVariant.add(variantId);
    }
  });

  //----
  //
  //----

  /** Variant Video Update **/
function updateVariantVideo(variantId) {
  const videoEls = document.querySelectorAll('.video__player.js-video'); // all video elements
  const newVideoUrl = window.variantVideos?.[variantId];

  if (!newVideoUrl) {
    // Optionally hide video if no video for this variant
    videoEls.forEach(v => v.style.display = 'none');
    return;
  }

  videoEls.forEach(videoEl => {
    videoEl.style.display = 'block';
    const source = videoEl.querySelector('source');
    if (source) {
      videoEl.pause();
      source.src = newVideoUrl;
      videoEl.load();
      videoEl.play();
    }
  });
}


});
